import md5 from 'md5';

const { v4: uuidv4 } = require('uuid');

const UtilString = {
  EMPTY_STRING: '',
  getAvatarName: (name) => {
    if (name) {
      return `${name?.split(' ')[0][0].toUpperCase()}${name && name.includes(' ') ? name?.split(' ')[1][0] : ''
        }`;
    }
    return '';
  },
  getStringToColor: (string) => {
    const colors = [
      '#1677ff', // blue
      '#6D28D9', // violet
      '#0284C7', // sky
      '#C2410C', // orange
      '#059669', // emerald
      '#DB2777', // pink
      '#4F46E5', // indigo
      '#0D9488', // teal
      '#B45309', // amber
      '#7C3AED', // purple
    ];
    let hash = 0;
    for (let i = 0; i < string?.length; i += 1) {
      hash = string?.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  },
  getUniqueString: () => {
    const uniqueId = uuidv4();
    return uniqueId;
  },
  md5: (str) => {
    return md5(str);
  },
};

export default UtilString;
